import { HStack, VStack } from '@genial/components';
import React from 'react';

import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const FixedFeeRelatedTermLoadingMobile: React.FC = () => {
  return (
    <HStack
      p="inset.xs"
      backgroundColor="backgroundshade"
      justifyContent="space-between"
      borderRadius="sm"
      space="inline.nano">
      <VStack space="stack.quarck" flex={1}>
        <TextSkeleton w="35%" h="12px" />
        <TextSkeleton w="50%" />
        <StatusSkeleton w="40%" />
      </VStack>

      <VStack space="stack.quarck" alignItems="flex-end" minW="110px">
        <TextSkeleton w="55%" h="12px" />
        <TextSkeleton w="75%" />
      </VStack>
    </HStack>
  );
};
